// frontend/src/components/PlatformAnnouncementBanner.js
//
// Shows any active TALIT platform announcements targeting this tenant that
// the current user hasn't dismissed. Stacks at the top of the app shell,
// severity-coloured. Dismissing calls the backend so it stays dismissed
// across sessions/devices. platform-admin §10 / Deploy A.
import React, { useEffect, useState, useCallback } from 'react';
import { Megaphone, X } from 'lucide-react';
import { apiFetch } from '../api/client';

const STYLE = {
  info: 'bg-sky-600 text-white',
  warning: 'bg-amber-500 text-white',
  critical: 'bg-red-600 text-white',
};

export default function PlatformAnnouncementBanner() {
  const [items, setItems] = useState([]);

  const load = useCallback(async () => {
    try {
      const res = await apiFetch('/tenant/announcements');
      const data = await res.json().catch(() => ({}));
      if (data.success) setItems(data.announcements || []);
    } catch { /* non-fatal */ }
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 5 * 60 * 1000); // refresh every 5 min
    return () => clearInterval(t);
  }, [load]);

  const dismiss = async (id) => {
    setItems((xs) => xs.filter((a) => a.id !== id));
    try {
      await apiFetch(`/tenant/announcements/${id}/dismiss`, { method: 'POST' });
    } catch { /* the optimistic removal already happened */ }
  };

  if (items.length === 0) return null;

  return (
    <>
      {items.map((a) => (
        <div
          key={a.id}
          className={`w-full text-sm flex items-start justify-between gap-3 px-4 py-2 ${STYLE[a.severity] || STYLE.info}`}
        >
          <span className="flex items-start gap-2 min-w-0">
            <Megaphone className="w-4 h-4 shrink-0 mt-0.5" />
            <span>
              <strong>{a.title}</strong>
              {a.body ? <span className="opacity-90"> — {a.body}</span> : null}
            </span>
          </span>
          <button
            onClick={() => dismiss(a.id)}
            className="shrink-0 inline-flex items-center gap-1 bg-white/15 hover:bg-white/25 rounded px-2 py-1 text-xs"
          >
            <X className="w-3.5 h-3.5" /> Dismiss
          </button>
        </div>
      ))}
    </>
  );
}
